/** Stripe Embedded Checkout client secrets may arrive URL-encoded from the API. */
export function normalizeStripeClientSecret(secret: string): string {
  if (!secret.includes("%")) return secret;
  try {
    return decodeURIComponent(secret);
  } catch {
    return secret;
  }
}
